BS.DOMReady(function() {
	var slides = [
		{ src: env.assets + "/img/sld01.jpg" },
	//	{ src: env.assets + "/img/sld02.jpg" },
		{ src: env.assets + "/img/sld03.jpg" },
	];

	var wrapE = BS.DOM.q(".slider-inner");
	if (!wrapE) {
		return;
	}

	wrapE.setAttribute("data-images", JSON.stringify(slides));

	new BS.Slideshow(wrapE, {
		interval: 5800,
		hoverToStop: false,
	});
});
 